import React, { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { StyleSheet } from 'react-native';
import { ColorScheme, theme } from '../../../constants/theme';
import { useThemeContext } from '../../../hook/useThemeManager';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { MainTagCarousel } from '../../EsCarousels/MainTagCarousel';
import { GenericModal } from '../../GenericModal/GenericModal';
import { reasons } from './reasons';

interface IContestPhaseSelector {
    onChange?: (arg: string) => void;
    open: boolean;
    handleOnClose: () => void;
}

const ReasonsSelector: React.FC<IContestPhaseSelector> = ({ onChange, open, handleOnClose }) => {
    const { themeStyle, device } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    const [value, setValue] = useState<string>('');

    const handleOnChange = (value: string) => {
        const selectedTag = reasons.find(e => e.displayName === value);
        if (selectedTag) {
            setValue(selectedTag.reason);
        }
    };
    const onSubmit = () => {
        onChange && onChange(value);
        handleOnClose();
    };
    return (
        <Stack direction="row" flexWrap="wrap" alignItems="center">
            <GenericModal open={open} handleClose={handleOnClose}>
                <Box>
                    <Box style={styles.flexColumn} sx={{ gap: '8px', width: '100%' }}>
                        <MainTagCarousel
                            carouselTitle="Select Title"
                            disregardParams
                            titleStyle={{
                                textAlign: 'left',
                                fontSize: 14,
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontFamily: FONT_ENUM.MAIN_REGULAR,
                                lineHeight: 2.5,
                                color: theme[themeStyle].form_label,
                                marginBottom: '10px',
                            }}
                            list={reasons.map(e => e.displayName)}
                            disableViewAll
                            onSelectTag={tag => handleOnChange(tag)}
                            style={{
                                marginBottom: 20,
                                display: 'block',
                            }}
                            listStyle={{
                                flexWrap: 'wrap',
                                gap: '10px',
                            }}
                        />
                    </Box>
                    <Button
                        onClick={onSubmit}
                        style={styles.detailsButton}
                        sx={{
                            textDecoration: 'none',
                            backgroundColor: theme[themeStyle].primary_orange,
                            color: theme[themeStyle].pure_black,
                            textTransform: 'none',
                            width: device.isMobile ? '100%' : '260px',
                            marginTop: '10px',
                            marginBottom: '10px',
                            '&:hover': {
                                border: `2px solid ${theme[themeStyle].primary_orange}`,
                                backgroundColor: theme[themeStyle].pure_black,
                                color: theme[themeStyle].primary_orange,
                            },
                        }}>
                        Add Reasons
                    </Button>
                </Box>
            </GenericModal>
        </Stack>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        text: {
            textAlign: 'left',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: '400',
            color: theme[colorScheme].form_label,
            fontFamily: FONT_ENUM.MAIN_REGULAR,
        },
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: 'fit-content',
        },
        detailsButton: {
            height: '52px',
            borderRadius: 100,
            fontSize: 16,
            fontWeight: '600',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            left: 20,
            bottom: 20,
        },
        customInput: {
            width: '100%',
            height: '100%',
            backgroundColor: theme[colorScheme].gray_text,
            borderRadius: 8,
            border: 'none',
        },
    });

export { ReasonsSelector };
